export const DEFAULT_ERROR = {
  isError: false,
  errorMessage: '',
};
